import { CommonModule } from '@angular/common';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { DropdownModule } from 'primeng/dropdown';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { TableModule } from 'primeng/table';
import { splitAgencyCode } from '../../../constants/general';
import { CASH_CONTROL_PATH } from '../../../enums/path';
import { TYPE } from '../../../enums/path-of-accounts';
import { AgencyCashControl } from '../../../models/cash-control/agency-cash';
import { Manager } from '../../../models/plan-accounts/account/create-account-request';
import { UserInfo } from '../../../models/user/user-info';
import { HttpUtilisCashControl } from '../../../network/http-utilis-cash-control';
import { HttpUtilisPlanOfAccounts } from '../../../network/http-utilis-plan-of-accounts';
import { CustomCurrencyPipe } from '../../../pipe/custom-currency.pipe';
import { CashControlService } from '../../../services/cash-control/cash-control.service';
import { ModalService } from '../../../services/modal/modal.service';
import { CalendarModule } from 'primeng/calendar';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-search-cash-control-screen',
  standalone: true,
  imports: [
    DropdownModule,
    CommonModule,
    TableModule,
    ProgressSpinnerModule,
    CalendarModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  templateUrl: './search-cash-control-screen.component.html',
  styleUrl: './search-cash-control-screen.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class SearchCashControlScreenComponent implements OnInit {
  managerOptions: Manager[] | undefined;
  isLoading: boolean = false;
  userInfo: UserInfo | undefined;

  constructor(
    private httpUtilisCashControl: HttpUtilisCashControl,
    public cashService: CashControlService,
    private router: Router,
    private httpPlanOfAccounts: HttpUtilisPlanOfAccounts,
    private modalService: ModalService,
    private messageService: MessageService
  ) {
    if (localStorage.getItem('userInfo')) {
      this.userInfo = UserInfo.fromJson(
        JSON.parse(localStorage.getItem('userInfo')!)
      );
    }
  }

  ngOnInit(): void {
    this.initState();
    if (this.cashService.isFirstTime) {
      this.cashService.isFirstTime = false;
    } else {
      this.getCashControls();
    }
  }

  onSubmit() {
    this.getCashControls();
  }

  onModify(event: MouseEvent, firstNote: AgencyCashControl) {
    event?.preventDefault();
    this.router.navigate([CASH_CONTROL_PATH.EDIT], {
      queryParams: { id: firstNote.id, fromSearch: 'true' },
    });
  }

  onDetail(event: MouseEvent, firstNote: AgencyCashControl) {
    event?.preventDefault();
    this.router.navigate([CASH_CONTROL_PATH.DETAIL], {
      queryParams: { id: firstNote.id },
    });
  }

  onModifyRedirect(firstNote: AgencyCashControl): string {
    return this.router
      .createUrlTree([CASH_CONTROL_PATH.EDIT], {
        queryParams: { id: firstNote.id, fromSearch: 'true' },
      })
      .toString();
  }

  onDetailRedirect(firstNote: AgencyCashControl) {
    return this.router
      .createUrlTree([CASH_CONTROL_PATH.DETAIL], {
        queryParams: { id: firstNote.id },
      })
      .toString();
  }

  initState() {
    this.isLoading = true;
    const agencyCode =
      this.userInfo?.agencyDescription.split(splitAgencyCode)[0];
    this.httpPlanOfAccounts
      .getAllInfos(
        TYPE.GESTORE_PN,
        'ONLY_GEST_PN',
        agencyCode,
        this.userInfo?.node
      )
      .subscribe({
        next: (response) => {
          this.managerOptions = response['types'];
          this.isLoading = false;
        },
        error: (error) => {
          this.modalService.showError(error);
          this.isLoading = false;
        },
      });
  }

  getCashControls() {
    const manager = this.cashService.searchForm.get('name')?.value ?? undefined;
    const interval = this.cashService.searchForm.get('interval')?.value;

    if (!interval || interval[0] === null || interval[1] === null) {
      return this.messageService.add({
        key: 'br',
        severity: 'error',
        summary: 'Errore',
        detail: 'Intervallo non valido',
      });
    }

    this.isLoading = true;
    this.httpUtilisCashControl.getCashControl(interval, manager).subscribe({
      next: (response: any) => {
        this.cashService.tableValues = AgencyCashControl.fromJsonArray(
          response['registers']
        );
        this.cashService.showSearchTable = true;
        this.isLoading = false;
      },
      error: (error) => {
        this.modalService.showError(error);
        this.isLoading = false;
      },
    });
  }
}
